import { ArrowRight, Sparkles } from 'lucide-react';
import './CTASection.css';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-bg">
        <div className="cta-glow glow-1" />
        <div className="cta-glow glow-2" />
      </div>
      
      <div className="cta-container">
        <div className="cta-content">
          <div className="cta-badge">
            <Sparkles className="badge-icon" />
            <span>Start exchanging today</span>
          </div>
          
          <h2 className="cta-title">
            Ready to Exchange{' '}
            <span className="gradient-text">Cryptocurrency?</span>
          </h2>
          
          <p className="cta-description">
            Join over 500,000 users who trust Omini Bridge for fast, secure, 
            and private cryptocurrency exchanges. No registration required.
          </p>

          <div className="cta-buttons">
            <a href="/" className="cta-btn primary">
              Start Exchange
              <ArrowRight className="btn-icon" />
            </a>
            <a href="/referral" className="cta-btn secondary">
              Earn Rewards
            </a>
          </div>

          <div className="cta-stats">
            <div className="cta-stat">
              <span className="stat-value">1000+</span>
              <span className="stat-label">Currencies</span>
            </div>
            <div className="cta-stat">
              <span className="stat-value">2 min</span>
              <span className="stat-label">Avg. time</span>
            </div>
            <div className="cta-stat">
              <span className="stat-value">0%</span>
              <span className="stat-label">Hidden fees</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
